<template>
  <div class="index">
    <div id="myCharts"></div>
    <div class="content">
      <div class="nav">
        <li @click="current = index" v-for="(item, index) in navList" :key="index"
          :class="index == current ? 'active' : ''">
          {{ item }}
        </li>
      </div>
      <div class="one" v-if="current == 0">
        <div class="p-10">
          <div class="tips">
            <span class="tips-left">
              教<br />
              程
            </span>
            <p>
              人气是成交的基础，提升店铺人气，让更多用户访问店铺，促进出价次数，达成成交。
            </p>
          </div>
        </div>
        <div class="lists">
          <div class="list">
            <p class="title">
              <span>粉丝数</span>
            </p>
            <div class="list-con">
              <span class="num">{{ info.fans.count ? info.fans.count : 0 }}人</span>
            </div>
          </div>
          <div class="list">
            <p class="title">
              <span>店铺访问</span>
            </p>
            <div class="list-con">
              <span class="num">{{ info.visit.count ? info.visit.count : 0 }}人</span>
            </div>
          </div>
        </div>
      </div>
      <div class="two" v-if="current == 1">
        <div class="p-10">
          <div class="tips">
            <span class="tips-left">
              教<br />
              程
            </span>
            <p>
              提升店铺转化率与成交量，扩大经营规模，能够让店铺在平台内等级排行上升，更好地运作
            </p>
          </div>
        </div>
        <div class="lists">
          <div class="list">
            <p class="title">
              <span>出价率</span>
              (7天内，出价的拍品数/发拍拍品数)
            </p>
            <div class="list-con">
              <span class="num">{{ info.bidRate.bidRatePercentage ? info.bidRate.bidRatePercentage : 0 }}</span>
              <p>
                <span class="text-orange">{{ info.bidRate.fraction ? info.bidRate.fraction : 0 }}分</span>
                <span class="text-gray">(满分{{ info.bidRate.fullMark ? info.bidRate.fullMark : 0 }}分)</span>
              </p>
            </div>
          </div>
          <div class="list">
            <p class="title">
              <span>付款率</span>
              (7天内，付款单数/成拍单数)
            </p>
            <div class="list-con">
              <span class="num">{{
                info.paymentRate.paymentRatePercentage ? info.paymentRate.paymentRatePercentage : 0
              }}</span>
              <p>
                <span class="text-orange">{{ info.paymentRate.fraction ? info.paymentRate.fraction : 0 }}分</span>
                <span class="text-gray">(满分{{ info.paymentRate.fullMark ? info.paymentRate.fullMark : 0 }}分)</span>
              </p>
            </div>
          </div>
          <div class="list">
            <p class="title">
              <span>交易完成率</span>
              (7天内，确认收货单数/成拍单数)
            </p>
            <div class="list-con">
              <span class="num">{{
                info.completeRate.receivingRatePercentage ? info.completeRate.receivingRatePercentage : 0
              }}</span>
              <p>
                <span class="text-orange">{{ info.completeRate.fraction ? info.completeRate.fraction : 0 }}分</span>
                <span class="text-gray">(满分{{ info.completeRate.fullMark ? info.completeRate.fullMark : 0 }}分)</span>
              </p>
            </div>
          </div>
          <div class="list">
            <p class="title">
              <span>近7天交易额</span>
              (7天内，用户付款金额)
            </p>
            <div class="list-con">
              <span class="num">￥{{ info.turnover.turnoverMoney ? info.turnover.turnoverMoney : 0 }}</span>
              <p>
                <span class="text-orange">{{ info.turnover.fraction ? info.turnover.fraction : 0 }}分</span>
                <span class="text-gray">(满分{{ info.turnover.fullMark ? info.turnover.fullMark : 0 }}分)</span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="three" v-if="current == 2">
        <div class="p-10">
          <div class="tips">
            <span class="tips-left">
              教<br />
              程
            </span>
            <p>
              及时回复购买私信，为用户提供更好的服务，促进买家复购，让店铺客流源源不断。
            </p>
          </div>
        </div>
        <div class="lists">
          <div class="list">
            <div class="list-con">
              <span class="num">
                  <span>店铺评分</span>
                  <span style="color: #999;font-size: 15px;">(店铺订单评分取平均值)</span>
              </span>
              <p>
                <span class="text-orange">{{ info.shopScore.fraction ? info.shopScore.fraction : 0 }}分</span>
                <span class="text-gray">(满分{{ info.shopScore.fullMark ? info.shopScore.fullMark : 0 }}分)</span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="four" v-if="current == 3">
        <div class="p-10">
          <div class="tips">
            <span class="tips-left">
              教<br />
              程
            </span>
            <p>
              信誉是店铺持续经营的重要因素，店铺信誉下降会直接影响买家的体验及店铺在平台展示权重
            </p>
          </div>
        </div>
        <div class="lists">
          <div class="list">
            <p class="title">
              <span>违约率</span>
              (违规单数/订单品数)
            </p>
            <div class="list-con">
              <span class="num">{{
                info.defaultRate.defaultRatePercentage ? info.defaultRate.defaultRatePercentage : 0
              }}</span>
              <p>
                <span class="text-orange">{{ info.defaultRate.fraction ? info.defaultRate.fraction : 0 }}分</span>
                <span class="text-gray">(满分{{ info.defaultRate.fullMark ? info.defaultRate.fullMark : 0 }}分)</span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="five" v-if="current == 4">
        <div class="p-10">
          <div class="tips">
            <span class="tips-left">
              教<br />
              程
            </span>
            <p>
              实名认证与店铺保证金数开店的基础，店铺资质与日常运营店铺息息相关
            </p>
          </div>
        </div>
        <div class="lists">
          <div class="list">
            <p class="title">
              <span>实名认证</span>
              (认证后享受9大特权)
            </p>
            <div class="list-con">
              <span class="num">{{ info.realName.authentication ? info.realName.authentication : 0 }}</span>
              <p>
                <span class="text-orange">{{ info.realName.fraction ? info.realName.fraction : 0 }}分</span>
                <span class="text-gray">(满分{{ info.realName.fullMark ? info.realName.fullMark : 0 }}分)</span>
              </p>
            </div>
          </div>
          <div class="list">
            <p class="title">
              <span>店铺保证金</span>
              (缴满3000元可提升星火段位)
            </p>
            <div class="list-con">
              <span class="num">￥{{ info.bond.bondMoney ? info.bond.bondMoney : 0 }}</span>
              <p>
                <span class="text-orange">{{ info.bond.fraction ? info.bond.fraction : 0 }}分</span>
                <span class="text-gray">(满分{{ info.bond.fullMark ? info.bond.fullMark : 0 }}分)</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import config from "../config/config";

export default {
  data() {
    return {
      navList: ["人气", "经营", "服务", "信誉", "资质"],
      current: 0,
      info: {
        fans: {}, // 粉丝数
        visit: {}, // 店铺访问
        bidRate: {}, // 出价率
        paymentRate: {}, // 付款率
        completeRate: {}, // 交易完成率
        turnover: {}, // 近7天交易额
        shopScore: {}, // 店铺评分
        defaultRate: {}, // 违约率
        realName: {}, // 实名认证
        bond: {}, // 店铺保证金

      },
      token: ""
    };
  },
  mounted() {
    var url = window.location.href.split("=");
    var num = url.length;
    this.token = url[num - 1];
    this.fetch();
  },
  methods: {
    fetch() {
      // let aaa = qs.stringify({
      //   type: this.type,
      //   timeType: this.timeType,
      // });

      axios.defaults.headers["Content-type"] =
        "application/x-www-form-urlencoded";
      axios.defaults.headers["token"] = this.token;
        // "eyJhbGciOiJIUzUxMiJ9.eyJsb2dpbl91c2VyX2tleSI6ImQ5ZDMzMGQ0LTViNTctNDQ4YS05ZDAxLWI0MDViNWQxMDg1ZCJ9.g9YCk0v6GsqaPnj4xX2eaY7h-_lpcNfGybN2fF4N0CTbfiBtzZtJqtPpOE4n4BpfhteezjSXi69HRvSik510AQ";

      axios
        .post(
          config.url + "api/immediate/reportForm/storeData"
          // ,
          // aaa
        )
        .then((res) => {
          this.info = res.data.data;
          this.aaa();
        });
    },

    change(index) {
      this.timeType = index;
    },

    aaa() {
      var chartDom = this.$echarts.init(document.getElementById("myCharts"));
      var option;
      var myData = [this.info.popularity, this.info.management, this.info.service, this.info.reputation, this.info.qualifications];
      console.log(myData, '=-==-=')
      option = {
        tooltip: {
          trigger: "axis",
        },
        legend: {
          left: "center",
          data: [""],
        },
        radar: [
          {
            indicator: [
              { text: "人气" + myData[0] + "分", max: 5, value: 0 },
              { text: "经营" + myData[1] + "分", max: 5, value: 1 },
              { text: "服务" + myData[2] + "分", max: 5, value: 2 },
              { text: "信用" + myData[3] + "分", max: 5, value: 3 },
              { text: "资质" + myData[4] + "分", max: 5, value: 4 },
            ],
            splitArea: {
              areaStyle: {
                color: ["#E6E6E6", "#fff", "#E6E6E6", "#fff", "#E6E6E6"],
                shadowColor: "#C0C0C0",
              },
            },
            triggerEvent: true,
            center: ["50%", "50%"],
            axisName: { formatter: "{value}", color: "#AFAFAF" },
            radius: 110,
            axisLine: {
              lineStyle: {
                color: "#C0C0C0",
              },
            },
          },
        ],
        series: [
          {
            type: "radar",
            tooltip: {
              //   trigger: "item",
            },
            areaStyle: {},
            data: [
              {
                value: myData,
                name: "A Software",

                color: ["#FF5000"],
                // backgroundColor: "rgba(255, 80, 0, 1)",
                areaStyle: {
                  color: "rgba(255, 80, 0, .8)",
                },

                label: {
                  show: true,
                  formatter: function (params) {
                    return params.value;
                  },
                },
              },
            ],
          },
        ],
      };
      var that = this;
      chartDom.on("click", function (param) {
        // //点击后执行操作
        // if (param.componentType === "radar") {
        //   // 点击到了 radar坐标轴标签 上
        //   console.log(11111);
        // } else if (param.componentType === "series") {
        //   console.log(2222);
        // }
        // console.log(param);
        // console.log(option.radar[0].indicator);
        // console.log(option.radar[0].indicator[param.event.topTarget.__dimIdx]);
        var con = option.radar[0].indicator[param.event.topTarget.__dimIdx];

        if (con) {
          var index = con.value;
          that.current = index;
        }
      });

      chartDom.setOption(option);
    },
  },
};
</script>

<style scoped>
.store-share {
  height: 60px;
  background: #ffffff;
  display: flex;
  padding: 0 10px;
  align-items: center;
  box-sizing: border-box;
}

.store-titles {
  color: #18191b;
  font-weight: 500;
  font-size: 15px;
}

.store-text {
  color: #999999;
  font-size: 13px;
}

.share-btn {
  width: 70px;
  height: 30px;
  border: 1px solid #ff5000;
  border-radius: 15px;
  text-align: center;
  line-height: 30px;
  color: #ff5000;
  font-size: 14px;
}

.left {
  flex: 1;
}

.store-title {
  height: 43px;
  text-indent: 10px;
  color: #666666;
  font-size: 14px;
  background: #f2f2f2;
  padding-top: 20px;
  box-sizing: border-box;
}

.p-10 {
  padding: 0 10px;
  box-sizing: border-box;
}

.list {
  border-bottom: 1px solid #eeeeee;
}

.lists {
  margin-top: 30px;
  padding: 0 10px;
  box-sizing: border-box;
}

.title {
  color: #999999;
  font-size: 13px;
  margin-top: 15px;
  margin-bottom: 5px;
}

.title span {
  color: #646464;
  font-size: 15px;
}

.list-con {
  display: flex;
  justify-content: space-between;
  padding-bottom: 10px;
}

.num {
  font-size: 15px;
  color: #333333;
  font-weight: 500;
}

.text-orange {
  color: #ff5000;
  font-size: 15px;
  font-weight: 500;
}

.text-gray {
  color: #999;
  font-size: 14px;
}

.content {
  background: #fff;
  padding-top: 20px;
  box-sizing: border-box;
  margin-top: -20px;
  z-index: 99;
  position: relative;
  border-radius: 10px 10px 0px 0px;
}

.tips {
  background: rgba(255, 80, 0, 0.1);
  border: 1px solid #ff5000;
  border-radius: 9px;
  color: #ff5000;
  margin-top: 20px;
  padding: 14px 5px;
  box-sizing: border-box;
  padding-left: 38px;
  position: relative;
  font-size: 14px;
}

.tips-left {
  position: absolute;
  left: 6px;
  font-size: 20px;
  font-weight: 500;
  padding-right: 4px;
  top: 50%;
  transform: translateY(-50%);
}

.tips-left::after {
  right: -3px;
  content: "";
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  height: 50px;
  width: 1px;
  background: #ff5000;
}

.nav {
  display: flex;
}

.nav li {
  flex: 1;
  font-size: 15px;
  color: #646464;
  text-align: center;
  transition: 0.3s all;
  position: relative;
  height: 25px;
  cursor: pointer;
}

.nav .active {
  columns: #18191b;
  font-size: 18px;
  font-weight: 500;
}

.nav li::after {
  content: "";
  position: absolute;
  width: 24px;
  height: 3px;
  transition: 0.3s all;
  bottom: -5px;
  left: 50%;
  transform: translateX(-50%);
  background: #ff5000;
  border-radius: 3px;
  opacity: 0;
}

.nav .active::after {
  opacity: 1;
}

* {
  margin: 0;
  padding: 0;
  list-style: none;
}

#myCharts {
  width: 100%;
  height: 300px;
  margin-bottom: 10px;
  background: #2a2a31;
}
</style>



// WEBPACK FOOTER //
// src/data.vue